// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-item:hover {
  background-color: #f6f9fc;
}

.notification-item.read {
  background-color: #f9f9f9;
}

@keyframes slideFadeIn {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
.notification-toast {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.toast-container .toast {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/NotificationPopover/styles.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE;IACE,4BAAA;IACA,UAAA;EACF;EACA;IACE,wBAAA;IACA,UAAA;EACF;AACF;AAEA;EACE,yCAAA;EACA,yBAAA;EACA,4DAAA;AAAF;;AAGA;EACE,yCAAA;AAAF","sourcesContent":[".notification-item:hover {\n  background-color: #f6f9fc;\n}\n\n.notification-item.read {\n  background-color: #f9f9f9;\n}\n\n@keyframes slideFadeIn {\n  0% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.notification-toast {\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.toast-container .toast {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
